module.exports = __webpack_public_path__ + "static/img/saga.0df4b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/saga.png
// module id = inUq
// module chunks = 2